import { render, staticRenderFns } from "./binding.vue?vue&type=template&id=3e5083ea&"
import script from "./binding.vue?vue&type=script&lang=js&"
export * from "./binding.vue?vue&type=script&lang=js&"
import style0 from "./binding.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports